/* Currently using fetch but is to simplify a future change to axios or another library
 */
export default async function (url, options) {
  return await fetch(url, options)
}
